// @flow
import { CALL_API } from 'api';
import { Schemas } from 'api/schema';
import { API_SEARCH_ROOT } from 'api/constants';
import * as ActionTypes from './actionTypes';
import * as Types from './types';
import every from 'lodash/every';
import remove from 'lodash/remove';

// Fetch categories
const fetchCategories = (url) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_CATEGORIES_REQUEST,
      ActionTypes.FETCH_CATEGORIES_SUCCESS,
      ActionTypes.FETCH_CATEGORIES_FAILURE
      ],
    endpoint: url,
    schema: Schemas.CATEGORY_ARRAY,
    resultProp: 'results.target_audience',
  }
});

export const getCategories = () => (dispatch, getState) => {
  const categories = getState().search.categories;
  if(categories.length > 0) {
    return Promise.resolve();
  }
  const url = 'categories';
  return dispatch(fetchCategories(url));
}

// Fetch results
const fetchResults = (nextPageUrl, searchType, sort = false, type, searchText = '') => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_SEARCH_REQUEST,
      ActionTypes.FETCH_SEARCH_SUCCESS,
      ActionTypes.FETCH_SEARCH_FAILURE,
      ],
    endpoint: nextPageUrl,
    schema: Schemas.SEARCH_RESULTS,
    resultProp: 'services.results',
    sortByParams: sort ? ['date_from'] : null,
  }
});

// Search action creator
export const doSearch = (query:Types.Query, nextPage:boolean = false) => (dispatch, getState) => {
  const stateQuery = getState().search.query;
  const equal = every(Object.keys(stateQuery), (key) => {
      return stateQuery[key] === query[key];
    }
  );
  if(equal && !nextPage) {
    return Promise.resolve();
  }

  if(!nextPage) {
    dispatch({
      type: ActionTypes.RESET,
    });
  }

  dispatch({
    type: ActionTypes.SET_SEARCH_PARAMS,
    query
  });

  let searchText = '';
  let type = 'location';

  const queryString = remove(Object.keys(query).map((key, index) => {
    if(key === 'location') {
      if(!query.location || query.location === '' || query.location === undefined || query.location.label === undefined) return null;

      if(query.location.type === Types.LocationTypes.GEO_LOCATION) {
        return `geo_location=${query.location.label}`;
      } else if(query.location.type === Types.LocationTypes.COURSE_NAME) {
        return `course=${query.location.label}`;
        //return `course=${query.location.label}&course_id=${query.location.id}`;
      } else {
        return `location=${query.location.label}`;
      }
    } else if(key === 'audience_id') {
      const categories = query.audience_id.join(',');
      if(categories.length) {
        return `audience_id=${categories}`;
      }
      return null;
    } else if(key === 'organizer_id') {
      const organizers = query.organizer_id.join(',');
      if(organizers.length) {
        return `organizer_id=${organizers}`;
      }
      return null;
    } else if(key === 'course_id') {
      const courses = query.course_id.join(',');
      if(courses.length) {
        return `course_id=${courses}`;
      }
      return null;
    }
    else if(key === 'text'){
      searchText = query[key];
      if(query[key]){
        type = 'freetext'
      }
      return ''
    }
    if(!!query[key]) {
      return `${key}=${query[key]}`;
    }
    return null;
  }), null).join('&');


  const {
    nextPageUrl = !!searchText ? `${API_SEARCH_ROOT}/search/${searchText}?${queryString}` : `search?${queryString}`,
    pageCount = 0
  } = getState().pagination.searchPaginated || {};

  if (pageCount > 0 && !nextPage) {
    return Promise.resolve();
  }
  if(pageCount > 0 && nextPage) {
    return dispatch({
      type: ActionTypes.NEXT_SEARCH_PAGE
    });
  }
  return dispatch(fetchResults(nextPageUrl, query.type, !!(query.organizer_id && query.organizer_id.length), type, searchText));
};



// WEBPACK FOOTER //
// ./src/modules/search/actions.js